import React, { useState } from "react";
import { Modal } from "react-bootstrap";

const SizeChartPopup = ({ productName, sizes, show, onClose }) => {
  const [unit, setUnit] = useState("cm"); // Default unit is cm

  // Group sizes by section
  const groupedSizes = sizes.reduce((acc, sizeItem) => {
    const section = sizeItem.section;
    if (!acc[section]) acc[section] = [];
    acc[section].push(sizeItem);
    return acc;
  }, {});

  const renderTable = (sectionName, sectionSizes) => {
    if (!sectionSizes || sectionSizes.length === 0) return null;

    const headers = sectionSizes.map((sizeItem) => sizeItem.size); // Sizes become headers
    const attributes = sectionSizes[0]?.attributes.map((attr) => attr.attribute_name) || []; // Attribute names as rows

    return (
      <div key={sectionName} className="mb-8">
        {/* Section Title */}
        <h3 className="text-center font-semibold mb-2">{sectionName}</h3>
        <div className="flex text-sm justify-center items-baseline mb-4">
          <p
            className={`px-2 cursor-pointer ${unit === "cm" ? "text-blue-700" : ""}`}
            onClick={() => setUnit("cm")}
          >
            CM
          </p>
          |
          <p
            className={`px-2 cursor-pointer ${unit === "inches" ? "text-blue-700" : ""}`}
            onClick={() => setUnit("inches")}
          >
            Inches
          </p>
        </div>
        {/* Table */}
        <table className="table-auto w-full text-sm border-collapse border border-gray-300 text-center">
          <thead>
            <tr className="bg-gray-200">
              <th className="border border-gray-300 px-4 py-2 capitalize">Attribute</th>
              {headers.map((header, index) => (
                <th key={index} className="border border-gray-300 px-4 py-2">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {attributes.map((attributeName, attrIndex) => (
              <tr key={attrIndex} className="hover:bg-gray-200">
                <td className="border border-gray-300 px-4 py-2 capitalize">{attributeName}</td>
                {sectionSizes.map((sizeItem, sizeIndex) => (
                  <td key={sizeIndex} className="border border-gray-300 px-4 py-2">
                    {unit === "cm"
                      ? sizeItem.attributes[attrIndex]?.value_in_cm
                      : sizeItem.attributes[attrIndex]?.value_in_inches}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <div className="flex justify-center w-full font-medium">
          {productName}
        </div>
      </Modal.Header>
      <Modal.Body>
        {/* Unit Selector */}
        {/* Render Tables by Section */}
        {Object.keys(groupedSizes).map((sectionName) =>
          renderTable(sectionName, groupedSizes[sectionName])
        )}
      </Modal.Body>
    </Modal>
  );
};

export default SizeChartPopup;
